import React from 'react';
import PropTypes from 'prop-types';

import { Error } from 'components/Message';

const ErrorMessage = ({ message, ...rest }) => <Error {...rest}>{message}</Error>;

ErrorMessage.defaultProps = {
  message: null,
};

ErrorMessage.propTypes = {
  message: PropTypes.string,
};

export default ErrorMessage;
